import dictionary from 'utils/dictionary';
import { Nullable } from 'utils/types';

export const headingSubtitleMessage = ({
  latitude,
  longitude,
}: {
  latitude: Nullable<string>;
  longitude: Nullable<string>;
}) => {
  if (!latitude || !longitude) return dictionary.domicilioDetail_subtitle;

  return (
    dictionary.domicilioDetail_subtitle +
    '\n' +
    dictionary.domicileDetail_lat +
    latitude +
    dictionary.domicileDetail_long +
    longitude
  );
};
